import React from "react";
import styled from "styled-components";
import AlertCircle from "./AlertCircle";

const WarningIcon = styled.div`
  position: absolute;
  width: 80px;
  height: 76px;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -38px;
`;

const ErrorMsg = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  margin-top: 43px;
  color: var(--text-color);
`;

function InternalError() {
  console.info("InternalError InternalError InternalError");
  return (
    <>
      <WarningIcon>
        <AlertCircle width={80} height={76} color="var(--text-color)" />
      </WarningIcon>
      <ErrorMsg>Could not get information</ErrorMsg>
    </>
  );
}

export default InternalError;
